import { ServiceRequestDetails } from '@commenda/types/src/service-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';

export enum ServiceRequestListExtensibleFields {
  OUTPUT_FILES = 'OUTPUT_FILES',
  ISSUES = 'ISSUES',
  SECURE_INFORMATION_REQUESTS = 'SECURE_INFORMATION_REQUESTS',
  NPS_TASK = 'NPS_TASK',
  WORKFLOW_EXECUTION = 'WORKFLOW_EXECUTION',
}

export const useServiceRequest = (
  id: string,
  queryParams?: {
    extends?: ServiceRequestListExtensibleFields[];
  }
) => {
  const queryParamsString = new URLSearchParams();

  if (queryParams?.extends?.length)
    queryParamsString.append('extends', queryParams.extends.join(','));

  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: ServiceRequestDetails;
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    id ? `${API_BASE_PATH}/${id}?${queryParamsString.toString()}` : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
};
